import accountApi from 'src/component/app/account/AccountApi'
import adSizeApi from 'src/component/app/adSize/AdSizeApi'
import advertiserApi from 'src/component/app/advertiser/AdvertiserApi'
import filterListApi from 'src/component/app/filterList/FilterListApi'
import sspApi from 'src/component/app/ssp/SspApi'
import {
    AccountBean,
    AdGroupBean,
    AdSizeBean,
    AdvertiserBean,
    CampaignBean,
    CountryBean,
    CreativeBean,
    FilterListBean,
    IabCategoryBean,
    ItemResponseAccountBeanObject,
    ItemResponseAdGroupBeanObject,
    ItemResponseAdSizeBeanObject,
    ItemResponseAdvertiserBeanObject,
    ItemResponseCampaignBeanObject,
    ItemResponseCreativeBeanObject,
    ItemResponseFilterListBeanObject,
    ItemResponseMediaAgencyBeanObject,
    ItemResponseRetargetingListBeanObject,
    ItemResponseSspBeanObject,
    LanguageBean,
    ListResponseAccountBean,
    ListResponseAdGroupBean,
    ListResponseAdSizeBean,
    ListResponseAdvertiserBean,
    ListResponseCampaignBean,
    ListResponseCreativeBean,
    ListResponseFilterListBean,
    ListResponseMediaAgencyBean,
    ListResponseRetargetingListBean,
    ListResponseSspBean,
    MediaAgencyBean,
    RetargetingListBean,
    SspBean,
    TimeZoneBean
} from '../api/api'
import adGroupApi from '../component/app/adGroup/AdGroupApi'
import campaignApi from '../component/app/campaign/CampaignApi'
import creativeApi from '../component/app/creative/CreativeApi'
import mediaAgencyApi from '../component/app/mediaAgency/MediaAgencyApi'
import dictionariesApi from './DictionariesApi'
import retargetingListApi from 'src/component/app/retargetingList/RetargetingListApi'

export interface LoadInfo {
    languages?: Array<LanguageBean>
    iabCategories?: Array<IabCategoryBean>
    countries?: Array<CountryBean>
    accounts?: Array<AccountBean>
    ssps?: SspBean[]
    mediaAgencies?: MediaAgencyBean[]
    advertisers?: AdvertiserBean[]
    campaigns?: CampaignBean[]
    adGroups?: AdGroupBean[]
    creatives?: CreativeBean[]
    adSizes?: AdSizeBean[]
    filterLists?: FilterListBean[]
    retargetingLists?: RetargetingListBean[]
    platforms?: Array<String>
    timeZones?: TimeZoneBean[]
}

export enum FormDataType {
    Languages,
    IabCategories,
    Countries,
    Accounts,
    Ssps,
    MediaAgencies,
    Advertisers,
    Campaigns,
    AdGroups,
    Creatives,
    AdSizes,
    FilterLists,
    RetargetingLists,
    Platforms,
    TimeZones
}

export function formDataLoader(...dictionaries: FormDataType[]): Promise<LoadInfo> {
    let res: Promise<LoadInfo> = Promise.resolve({})
    for (const dictionary of dictionaries) {
        switch (dictionary) {
            case FormDataType.Ssps:
                res = res.then((loadInfo: LoadInfo) => {
                    return sspApi
                        .all()
                        .then((response: ListResponseSspBean) => {
                            const array = response.data as Array<ItemResponseSspBeanObject>
                            const ssps: SspBean[] = array.map(item => item.data as SspBean)
                            return Promise.resolve({
                                ...loadInfo,
                                ssps
                            })
                        })
                })
                break
            case FormDataType.Accounts:
                res = res.then((loadInfo: LoadInfo) => {
                    return accountApi
                        .all()
                        .then((response: ListResponseAccountBean) => {
                            const array = response.data as Array<ItemResponseAccountBeanObject>
                            const accounts: AccountBean[] = array.map(item => item.data as AccountBean)
                            return Promise.resolve({
                                ...loadInfo,
                                accounts
                            })
                        })
                })
                break
            case FormDataType.Languages:
                res = res.then(async (loadInfo: LoadInfo) => {
                    const languages = await dictionariesApi.languages()
                    return Promise.resolve({ ...loadInfo, languages })
                })
                break
            case FormDataType.MediaAgencies:
                res = res.then((loadInfo: LoadInfo) => {
                    return mediaAgencyApi
                        .all()
                        .then((response: ListResponseMediaAgencyBean) => {
                            const array = response.data as Array<ItemResponseMediaAgencyBeanObject>
                            const mediaAgencies: MediaAgencyBean[] = array.map(item => item.data as MediaAgencyBean)
                            return Promise.resolve({
                                ...loadInfo,
                                mediaAgencies
                            })
                        })
                })
                break
            case FormDataType.Advertisers:
                res = res.then((loadInfo: LoadInfo) => {
                    return advertiserApi
                        .all()
                        .then((response: ListResponseAdvertiserBean) => {
                            const array = response.data as Array<ItemResponseAdvertiserBeanObject>
                            const advertisers: AdvertiserBean[] = array.map(item => item.data as AdvertiserBean)
                            return Promise.resolve({
                                ...loadInfo,
                                advertisers
                            })
                        })
                })
                break
            case FormDataType.Campaigns:
                res = res.then((loadInfo: LoadInfo) => {
                    return campaignApi
                        .all()
                        .then((response: ListResponseCampaignBean) => {
                            const array = response.data as Array<ItemResponseCampaignBeanObject>
                            const campaigns: CampaignBean[] = array.map(item => item.data as CampaignBean)
                            return Promise.resolve({
                                ...loadInfo,
                                campaigns
                            })
                        })
                })
                break
            case FormDataType.AdGroups:
                res = res.then((loadInfo: LoadInfo) => {
                    return adGroupApi
                        .all()
                        .then((response: ListResponseAdGroupBean) => {
                            const array = response.data as Array<ItemResponseAdGroupBeanObject>
                            const adGroups: AdGroupBean[] = array.map(item => item.data as AdGroupBean)
                            return Promise.resolve({
                                ...loadInfo,
                                adGroups
                            })
                        })
                })
                break
            case FormDataType.Creatives:
                res = res.then((loadInfo: LoadInfo) => {
                    return creativeApi
                        .all()
                        .then((response: ListResponseCreativeBean) => {
                            const array = response.data as Array<ItemResponseCreativeBeanObject>
                            const creatives: CreativeBean[] = array.map(item => item.data as CreativeBean)
                            return Promise.resolve({
                                ...loadInfo,
                                creatives
                            })
                        })
                })
                break
            case FormDataType.IabCategories:
                res = res.then((loadInfo: LoadInfo) => {
                    return dictionariesApi.iabCategories()
                        .then((iabCategories: Array<IabCategoryBean>) => {
                            return Promise.resolve({ ...loadInfo, iabCategories })
                        })
                })
                break
            case FormDataType.AdSizes:
                res = res.then((loadInfo: LoadInfo) => {
                    return adSizeApi
                        .all()
                        .then((response: ListResponseAdSizeBean) => {
                            const array = response.data as Array<ItemResponseAdSizeBeanObject>
                            const adSizes: AdSizeBean[] = array.map(item => item.data as AdSizeBean)
                            return Promise.resolve({
                                ...loadInfo,
                                adSizes
                            })
                        })
                })
                break
            case FormDataType.FilterLists:
                res = res.then((loadInfo: LoadInfo) => {
                    return filterListApi
                        .all()
                        .then((response: ListResponseFilterListBean) => {
                            const array = response.data as Array<ItemResponseFilterListBeanObject>
                            const filterLists: FilterListBean[] = array.map(item => item.data as FilterListBean)
                            return Promise.resolve({
                                ...loadInfo,
                                filterLists
                            })
                        })
                })
                break
            case FormDataType.RetargetingLists:
                res = res.then((loadInfo: LoadInfo) => {
                    return retargetingListApi
                        .all()
                        .then((response: ListResponseRetargetingListBean) => {
                            const array = response.data as Array<ItemResponseRetargetingListBeanObject>
                            const retargetingLists: RetargetingListBean[] = array.map(item => item.data as RetargetingListBean)
                            return Promise.resolve({
                                ...loadInfo,
                                retargetingLists
                            })
                        })
                })
                break
            case FormDataType.Countries:
                res = res.then((loadInfo: LoadInfo) => {
                    return dictionariesApi.countries()
                        .then((countries: Array<CountryBean>) => {
                            return Promise.resolve({ ...loadInfo, countries })
                        })
                })
                break
            case FormDataType.Platforms:
                res = res.then((loadInfo: LoadInfo) => {
                    return dictionariesApi.platforms()
                        .then((platforms: Array<String>) => {
                            return Promise.resolve({ ...loadInfo, platforms: platforms })
                        })
                })
                break
            case FormDataType.TimeZones:
                res = res.then((loadInfo: LoadInfo) => {
                    return dictionariesApi.timezones()
                        .then((timezones: Array<TimeZoneBean>) => {
                            return Promise.resolve({ ...loadInfo, timezones })
                        })
                })
                break
        }
    }
    return res
}


// WEBPACK FOOTER //
// ./src/util/FormDataLoader.ts